import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ArrowIcon from "@material-ui/icons/ArrowForward";
import UserIcon from "@material-ui/icons/PersonOutline";
import HeartIcon from "@material-ui/icons/FavoriteBorderSharp";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import { WidgetProps } from "../widgets";
import ImageEnlarge from "../ui/Media/ImageEnlarge";
import { IImage } from "../../models/Image";
import { FileType } from "../../laco-common/base/models/IFile";
import homeImage1 from "../../assets/tempImages/Rich.jpg";
import homeImage2 from "../../assets/tempImages/homeImage2.jpeg";
import homeImage3 from "../../assets/tempImages/homeImage3.jpeg";
import homeImage4 from "../../assets/tempImages/homeImage4.jpeg";
import homeImageBlue from "../../assets/tempImages/homeImageBlue.jpeg";
import homeDonate from "../../assets/tempImages/donationCard-small.png";
import ImageView from "../ui/Media/ImageView";
import "./HomeBlue.scss";

type BenefitsWidgetProps = {} & WidgetProps;

const services: {
	title: string;
	desc: string;
	icon: any;
	imageUrl: string;
	url: string;
	linkText: string;
	externalLink?: boolean;
}[] = [
	{
		title: "Member Benefit Insurance Services",
		desc: "The Benefit & Welfare Association has partnered up with Colonial to provide a Firefighter insurance package for our members.",
		icon: <UserIcon color="primary" />,
		imageUrl: homeImage1,
		url: "https://www.lacbw.com/",
		externalLink: true,
		linkText: "View Benefits",
	},
	{
		title: "Give Back",
		desc: "Your donations will go directly to our fire family members.",
		icon: <HeartIcon color="primary" />,
		imageUrl: homeImage2,
		url: "/donate",
		linkText: "Donate",
	},
	{
		title: "Subscribe to Straight Streams",
		desc: "The magazine and information resources for the LA County Firefighters' B&W Association.",
		icon: <EmailOutlinedIcon color="primary" />,
		imageUrl: homeImage3,
		url: "/join",
		linkText: "Subscribe",
	},
	{
		title: "Equipment Request",
		desc: "Request Medical Equipment including: Wheelchairs, Crutches, Canes, Knee Scooters, and more.",
		icon: <AssignmentOutlinedIcon color="primary" />,
		imageUrl: homeImage4,
		url: "/medical-equipment",
		linkText: "Submit",
	},
];

export const HomeBlueWidget: React.FC<BenefitsWidgetProps> = (props: BenefitsWidgetProps) => {
	// const [Component, setComponent] = useState<any>(null);

	useEffect(() => {}, []);

	const media: IImage = {
		filename: "",
		fileType: FileType.IMAGE,
		url: homeImageBlue,
	}; //getSiteMedia();

	return (
		<>
			<div className="container section-padding d-flex align-items-center justify-content-center pb-2">
				<NavLink
					to="/donate"
					className="d-inline-block w-100-sm w-75 d-flex align-items-center justify-content-center"
				>
					<img className="scale-on-hover highlight-on-hover  donate-image" src={homeDonate} />
				</NavLink>
			</div>
			<div className="container section-padding">
				<div className="mt-3 mb-5">
					<h3 className="text-center">About B&W | For members by members</h3>
					<p className="text-center">
						The Los Angeles County Firemen’s Benefit & Welfare Association is a non-profit organization
						founded and administered by its members. These members include both active and retired employees
						of the LACoFD.
					</p>
				</div>
				<div className="cards-container w-blue-box">
					{services.map(({ title, desc, imageUrl, icon, url, linkText, externalLink = false }, i) => {
						const content = (
							<div className="card bg-light" key={i}>
								<ImageView
									className="card-img-top"
									image={{ ...media, url: imageUrl }}
									imageWidth100Pct
									viewHeight={180}
									renderContainer
								/>
								<div className="card-body">
									<span className="card-icon">{icon}</span>
									<h4 className="card-title">{title}</h4>
									<p className="card-text" style={{ fontSize: "15px" }}>
										{desc}
									</p>
									<OrangeArrowLink text={linkText} url={url} />
								</div>
							</div>
						);
						if (externalLink)
							return (
								<a href={url} target="_blank" key={i} className="scale-in-image-view d-inline-block">
									{content}
								</a>
							);
						return (
							<NavLink to={url} key={i} className="scale-in-image-view d-inline-block">
								{content}
							</NavLink>
						);
					})}
				</div>

				<div className="blue-box">
					<div className="d-flex flex-column-reverse flex-lg-row-reverse justify-content-between align-items-stretch flex-equal-width-container">
						<div className="align-self-stretch flex-grow-1 pl-7 pl-0-mobile-tablet">
							<ImageEnlarge image={media} isPercentage imageWidth100Pct scaleInEffect />
						</div>
						<div className="align-self-center">
							<h1>Membership in the B&W</h1>
							<p className="py-2">
								All permanent employees of the Los Angeles County Fire Department are eligible for
								membership. The operating costs of the association are supported by a voluntary monthly
								payroll deduction from the active membership. The cost is $20 per month and is tax
								deductible. For enrolment assistance, contact your Battalion Director.
							</p>
							<NavLink to="/membership">
								<button className="btn btn-default white" style={{ minWidth: "150px" }}>
									Join Now
								</button>
							</NavLink>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

type OrangeArrowLinkProps = {
	url: string;
	text?: string;
};

export const OrangeArrowLink: React.FC<OrangeArrowLinkProps> = ({ url, text }) => {
	if (!url) return null;
	return (
		<span
			className="text-primary arrow-link text-uppercase w-100 d-inline-flex align-items-center py-1 pr-1 font-weight-bold"
			// to={url}
			style={{ fontSize: "13px" }}
		>
			<span>{text || url}</span>
			<ArrowIcon style={{ fontSize: "16px", marginLeft: "3px" }} />
		</span>
	);
};
